class RVLiveSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector(".swiper");
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const nextButton = this.querySelector(".swiper-button-next");
    const prevButton = this.querySelector(".swiper-button-prev");

    const swiperParams = {
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      slidesPerView: 1.6,
      spaceBetween: 8,
      breakpoints: {
        1200: {
          //当屏幕宽度大于等于1200
          slidesPerView: 4,
          spaceBetween: 8,
        },
        1000: {
          //当屏幕宽度大于等于850
          slidesPerView: 2.8,
          spaceBetween: 8,
        },
        900: {
          //当屏幕宽度大于等于850
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
        850: {
          //当屏幕宽度大于等于850
          slidesPerView: 2,
          spaceBetween: 8,
        },
        768: {
          //当屏幕宽度大于等于768
          slidesPerView: 1.6,
          spaceBetween: 8,
        },
        500: {
          //当屏幕宽度大于等于500
          slidesPerView: 3,
          spaceBetween: 8,
        },
      },
    };

    // 保存主 swiper 实例到 window
    window.mainSwiper = new Swiper(this.swiper, swiperParams);
  }
}
customElements.define("rv-live-swiper", RVLiveSwiper);

class RVLiveModalSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector(".swiper");
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const nextButtons = this.querySelectorAll(".swiper-button-next");
    const prevButtons = this.querySelectorAll(".swiper-button-prev");

    const updateButtonState = (swiper) => {
      // 全部启用
      nextButtons.forEach((btn) => btn.removeAttribute("disabled"));
      prevButtons.forEach((btn) => btn.removeAttribute("disabled"));

      // 第一张禁用 prev
      if (swiper.isBeginning)
        prevButtons.forEach((btn) => btn.setAttribute("disabled", true));
      // 最后一张禁用 next
      if (swiper.isEnd)
        nextButtons.forEach((btn) => btn.setAttribute("disabled", true));
    };

    // 初始化 Swiper
    window.modalSwiper = new Swiper(this.swiper, {
      slidesPerView: 1,
      on: {
        init: (swiper) => updateButtonState(swiper),
        slideChange: (swiper) => updateButtonState(swiper),
      },
    });

    // 点击事件
    nextButtons.forEach((btn) =>
      btn.addEventListener("click", () => window.modalSwiper.slideNext())
    );
    prevButtons.forEach((btn) =>
      btn.addEventListener("click", () => window.modalSwiper.slidePrev())
    );
  }
}

customElements.define("rv-live-modal-swiper", RVLiveModalSwiper);

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("image-modal");

  if (modal) {
    const closeBtn = modal.querySelector(".modal-close");

    // 点击 overlay 打开 modal
    document
      .querySelectorAll(".swiper-slide .overlay")
      .forEach((overlay, index) => {
        overlay.addEventListener("click", (e) => {
          if (window.modalSwiper) {
            modal.classList.remove("hidden");
            window.modalSwiper.slideTo(index); // 跳转到对应 slide

            window.modalSwiper.update();
            window.modalSwiper.emit("slideChange"); // 触发 slideChange，更新按钮
          }
        });
      });

    // 关闭按钮
    closeBtn.addEventListener("click", () => {
      modal.classList.add("hidden");
    });

    // 点击遮罩关闭
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.classList.add("hidden");
      }
    });
  }

});
